import { Box, Stack } from "@mui/material";
import { Fragment } from "react";
import { SectionHeader } from "routes/Customer/Waste/Manifests/sections/SectionHeader";

import { ClassificationOutcomeCard } from "./ClassificationOutcomeCard";
import { Differences } from "./differences";
import { EXPLAINED_SECTIONS } from "./explainedFields";
import { FieldGroupHeading } from "./FieldGroupHeading";
import { WasteClassificationExplanation } from "./types";

/** One outcome card per explained field, grouped into the portal's sections. */
export function WasteClassificationSections({
  explanation,
  differences,
}: {
  explanation: WasteClassificationExplanation;
  differences: Differences;
}) {
  const { result, reasons } = explanation;

  return (
    <Stack gap={3}>
      {EXPLAINED_SECTIONS.map((section) => (
        <Box key={section.key}>
          <SectionHeader title={section.label} />
          <Stack gap={2}>
            {section.fields.map((field, index) => (
              <Fragment key={field}>
                {index === 1 && section.siblingsHeading && (
                  <FieldGroupHeading>{section.siblingsHeading}</FieldGroupHeading>
                )}
                <ClassificationOutcomeCard
                  field={field}
                  result={result}
                  ruleDescriptions={reasons
                    .filter((reason) => reason.field === field)
                    .map((reason) => reason.description)}
                  difference={differences[field]}
                />
              </Fragment>
            ))}
          </Stack>
        </Box>
      ))}
    </Stack>
  );
}
